function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.8125 2.28125L6.125 6.59375L10.4062 2.28125C10.7812 1.90625 11.4375 1.90625 11.8125 2.28125C12.2188 2.6875 12.2188 3.3125 11.8125 3.71875L7.53125 8L11.8125 12.2812C12.2188 12.6875 12.2188 13.3125 11.8125 13.7188C11.4375 14.0938 10.78125 14.0938 10.4062 13.7188L6.125 9.40625L1.8125 13.7188C1.4375 14.0938 0.78125 14.0938 0.40625 13.7188C0 13.3125 0 12.6875 0.40625 12.2812L4.6875 8L0.40625 3.71875C0 3.3125 0 2.6875 0.40625 2.28125C0.78125 1.90625 1.4375 1.90625 1.8125 2.28125Z",
  fill: "black"
});

function SvgPhishingManagerWarningToastClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhishingManagerWarningToastClose);
export default __webpack_public_path__ + "static/media/phishing-manager-warning-toast-close.b100a109.svg";
export { ForwardRef as ReactComponent };